var util = require("../util");

module.exports = function(o, n) {
    "object" == typeof o && (o = util.serialize(o));
    var e = n + o;
    window && window.navigator && "function" == typeof window.navigator.sendBeacon ? window.navigator.sendBeacon(e, "&post_res=") : util.warn("[arms] navigator.sendBeacon not surported");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_alife-logger@1.8.30@alife-logger/lib/common/sendBeacon.js
// module id = 0Sg3
// module chunks = 68